// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2iX8A","seat__container":"seat__container-Ersul","seat":"seat-3Venw"};